import React, {useState} from 'react';

import {FormControl, InputLabel, MenuItem, Select as MuiSelect,} from '@mui/material';

import {Field} from 'react-final-form';
import {ErrorMessage, showErrorOnChange, useFieldForErrors} from "./utils";
import classnames from "classnames";


export const Select = (props) => {
    const {
        name,
        label,
        data,
        children,
        required,
        multiple,
        helperText,
        fieldProps,
        inputLabelProps,
        formControlProps,
        formHelperTextProps,
        menuItemProps,
        showError = showErrorOnChange,
        onChange,
        ...restSelectProps
    } = props;

    if (!data && !children) {
        console.log(data);
        throw new Error('Please specify either children or data as an attribute.');
    }

    const {variant} = restSelectProps;
    const field = useFieldForErrors(name);
    const isError = showError(field);
    const [open, setOpen] = useState(false);


    return (
        <Field
            name={name}
            render={({input: {name, value, onChange: onChangeInput, ...restInput}}) => {
                // prevents an error that happens if you don't have initialValues defined in advance
                const finalValue = multiple && !value ? [] : value;
                const labelId = `select-input-${name}`;

                const oC = (e) => {
                    onChangeInput(e);
                    if (onChange) onChange(e)
                    if (multiple) {
                        setOpen(false);
                    }
                }

                return (
                    <FormControl
                        required={Boolean(required)}
                        error={isError}
                        fullWidth={true}
                        variant={variant}
                        {...formControlProps}
                    >
                        {!!label && (
                            <InputLabel id={labelId} {...inputLabelProps}>
                                {label}
                            </InputLabel>
                        )}
                        <MuiSelect
                            {...(multiple
                                ? {open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false)}
                                : {})
                            }
                            name={name}
                            value={finalValue}
                            onChange={oC}
                            multiple={multiple}
                            label={label}
                            labelId={labelId}
                            inputProps={{required, ...restInput, ...restSelectProps.inputProps}}
                            {...restSelectProps}
                            className={classnames('MuiInput-formControl', restSelectProps.className)}
                        >
                            {data
                                ? data.map(item => (
                                    <MenuItem
                                        value={item.value}
                                        key={item.value}
                                        disabled={item.disabled}
                                        {...(menuItemProps)}
                                    >
                                        {item.label}
                                    </MenuItem>
                                ))
                                : children}
                        </MuiSelect>
                        <ErrorMessage
                            showError={isError}
                            meta={field.meta}
                            formHelperTextProps={formHelperTextProps}
                            helperText={helperText}
                        />
                    </FormControl>
                );
            }}
            {...fieldProps}
        />
    );
}

export default Select;
